import React from 'react'
import { Button, type ButtonProps } from '@mantine/core'

export type AppButtonProps = ButtonProps

/**
 * Standard button with ember color and sm radius.
 * Default height: 36px (Mantine size="sm" equivalent)
 */
function AppButtonRoot ({ size = 'sm', ...props }: AppButtonProps) {
  return <Button color="ember" radius="sm" size={size} {...props} />
}

const AppButton = Object.assign(AppButtonRoot, {
  Group: Button.Group
})

export default AppButton
